<div class="modal-error bg-color-background-3 ">
  <sit-icon [icon]="cancelIcon" alt="icono cancelar" [sizeClass]="'icon-size-58'"></sit-icon>

  <span class="text-white text-size-20 text-sm-size-14 text-weight-600 p-1">{{
    errorMessage || 'No se pudo realizar la operación'
    }}</span>
</div>